/* ==========================================================================
   D_TODO_GT — scripts propios
   Todo vanilla, sin librerias. Una funcion init por componente; cada una
   comprueba primero si su elemento existe, asi el mismo archivo sirve para
   todas las paginas.
   ========================================================================== */

(function () {
  'use strict';

  var sinMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- Animaciones de entrada al hacer scroll ----------------------------- */

  function initReveals() {
    var elementos = document.querySelectorAll('.dt-reveal:not(.dt-visible)');
    if (!elementos.length) return;

    if (sinMovimiento || !('IntersectionObserver' in window)) {
      elementos.forEach(function (el) {
        el.classList.add('dt-visible');
      });
      return;
    }

    var observador = new IntersectionObserver(
      function (entradas) {
        entradas.forEach(function (entrada) {
          if (!entrada.isIntersecting) return;
          entrada.target.classList.add('dt-visible');
          observador.unobserve(entrada.target);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -60px 0px' }
    );

    elementos.forEach(function (el) {
      observador.observe(el);
    });
  }

  /* --- Galeria de la pagina de producto ----------------------------------- */

  function initGaleria() {
    var galerias = document.querySelectorAll('[data-dt-galeria]');
    if (!galerias.length) return;

    galerias.forEach(function (galeria) {
      var principal = galeria.querySelector('[data-dt-galeria-principal]');
      var miniaturas = galeria.querySelectorAll('[data-dt-mini]');
      if (!principal || !miniaturas.length) return;

      miniaturas.forEach(function (mini) {
        mini.addEventListener('click', function () {
          var url = mini.getAttribute('data-dt-mini');
          if (!url) return;

          principal.src = url;
          var alt = mini.getAttribute('data-dt-mini-alt');
          principal.alt = alt || '';

          miniaturas.forEach(function (m) {
            m.classList.remove('is-activa');
            m.setAttribute('aria-current', 'false');
          });
          mini.classList.add('is-activa');
          mini.setAttribute('aria-current', 'true');
        });
      });
    });
  }

  /* --- Selector de variantes ---------------------------------------------- */

  function initVariantes() {
    var bloques = document.querySelectorAll('[data-dt-variantes]');
    if (!bloques.length) return;

    bloques.forEach(function (bloque) {
      var datos = bloque.querySelector('[data-dt-variantes-json]');
      var selects = bloque.querySelectorAll('[data-dt-opcion]');
      var inputId = bloque.querySelector('[data-dt-variante-id]');
      var precioActual = bloque.querySelector('[data-dt-precio-actual]');
      var precioAntes = bloque.querySelector('[data-dt-precio-antes]');
      var boton = bloque.querySelector('[data-dt-boton-comprar]');
      var botonComprarAhora = bloque.querySelector('[data-dt-boton-comprar-ahora]');
      var stock = bloque.querySelector('[data-dt-stock]');

      if (!datos || !selects.length || !inputId) return;

      var variantes;
      try {
        variantes = JSON.parse(datos.textContent);
      } catch (e) {
        return;
      }
      if (!Array.isArray(variantes)) return;

      var textoAgotado = boton ? boton.getAttribute('data-texto-agotado') || 'Agotado' : '';
      var textoComprar = boton ? boton.getAttribute('data-texto-comprar') || 'Añadir al carrito' : '';
      var textoAgotadoComprarAhora = botonComprarAhora ? botonComprarAhora.getAttribute('data-texto-agotado') || 'Agotado' : '';
      var textoComprarAhora = botonComprarAhora ? botonComprarAhora.getAttribute('data-texto-comprar') || 'COMPRAR AHORA' : '';

      function seleccionActual() {
        return Array.prototype.map.call(selects, function (s) {
          return s.value;
        });
      }

      function actualizar() {
        var elegidas = seleccionActual();

        var variante = variantes.find(function (v) {
          return elegidas.every(function (valor, i) {
            return v.options[i] === valor;
          });
        });

        if (!variante) {
          if (boton) {
            boton.disabled = true;
            boton.textContent = textoAgotado;
          }
          if (botonComprarAhora) {
            botonComprarAhora.disabled = true;
            botonComprarAhora.textContent = textoAgotadoComprarAhora;
          }
          return;
        }

        inputId.value = variante.id;

        if (precioActual && variante.price_formatted) {
          precioActual.textContent = variante.price_formatted;
        }

        if (precioAntes) {
          if (variante.compare_formatted) {
            precioAntes.textContent = variante.compare_formatted;
            precioAntes.hidden = false;
          } else {
            precioAntes.hidden = true;
          }
        }

        if (stock) {
          stock.textContent = variante.available
            ? stock.getAttribute('data-texto-disponible') || 'Disponible'
            : stock.getAttribute('data-texto-agotado') || 'Agotado';
          stock.classList.toggle('dt-prod__stock--agotado', !variante.available);
        }

        if (boton) {
          boton.disabled = !variante.available;
          boton.textContent = variante.available ? textoComprar : textoAgotado;
        }

        if (botonComprarAhora) {
          botonComprarAhora.disabled = !variante.available;
          botonComprarAhora.textContent = variante.available ? textoComprarAhora : textoAgotadoComprarAhora;
        }
      }

      selects.forEach(function (s) {
        s.addEventListener('change', actualizar);
      });

      actualizar();
    });
  }

  /* --- Arranque ----------------------------------------------------------- */

  function iniciar() {
    initReveals();
    initGaleria();
    initVariantes();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }

  // El editor de Shopify recarga secciones sueltas sin recargar la pagina.
  document.addEventListener('shopify:section:load', iniciar);
})();
